var render, staticRenderFns
import script from "./indexCopy1.vue?vue&type=script&lang=js"
export * from "./indexCopy1.vue?vue&type=script&lang=js"
import style0 from "./indexCopy1.vue?vue&type=style&index=0&id=2bcf535b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcf535b",
  null
  
)

export default component.exports